import { keyframes } from 'styled-components';

export const appearLeft = keyframes`
  from {
    position: relative;
    left: -100%;
    opacity: 0.7;
  }

  to {
    position: relative;
    left: 0;
    opacity: 1.0;
  }
`;

export const appearRight = keyframes`
  from {
    position: relative;
    right: -100%;
    opacity: 0.7;
  }

  to {
    position: relative;
    right: 0;
    opacity: 1.0;
  }
`;

export const fadeIn = keyframes`
  from {
    position: relative;
    opacity: 0.0;
  }

  to {
    position: relative;
    opacity: 1.0;
  }
`;

export const blinkTextCursor = keyframes`
  from {border-right-color: white;}
  to {border-right-color: transparent}
`;
